














































import {Vue, Component} from "vue-property-decorator";
import SectionHeader from "@/components/SectionHeader.vue";
import NavBar from "@/components/NavBar.vue";
import Loading from "@/components/Loading.vue";
import tippy from "tippy.js";
import LoraParserRow from "@/components/loraParser/LoraParserRow.vue";
import LoraParserRowMobile from "@/components/loraParser/LoraParserRowMobile.vue";
import {CoreClient, curCoreClient} from "@/services/CoreClient";
import {LoraParser} from "@/types/core";

@Component({
  components: {
    LoraParserRow,
    LoraParserRowMobile,
    NavBar,
    SectionHeader,
    Loading
  }
})
export default class LoraParserList extends Vue{

  error = '';
  httpBusy = false;
  loraParserList:LoraParser[] = [];

  // internal dependencies
  private coreClient:CoreClient = curCoreClient;

  mounted() {
    tippy('[data-tippy-content]');

    this.refreshData()
  }

  async refreshData(){
    this.error = '';
    this.httpBusy = true;

    // we currently support up to 1000 custom parsers
    const reply = await this.coreClient.getLoraParsers({skip:0, limit:1000});

    this.httpBusy = false;

    if (reply.httpCode === 403)
      return this.$router.push({name: 'login'});

    if (reply.errorMsg)
      return this.error = `Unable to load decoders because ${reply.errorMsg}`;

    this.loraParserList = reply.loraParserList as LoraParser[];

  }

  get showLoading() {
    return this.httpBusy;
  }

  get showParserList() {
    return this.loraParserList.length > 0;
  }

  get showNoParsers() {
    return !this.httpBusy && this.loraParserList.length === 0;
  }
}
